module.exports = __webpack_public_path__ + "img/20200302154043542.efead947.jpg";